import { Commentaries as CommentariesComponent } from './Commentaries.component';
import { connector } from './Commentaries.connector';

export const Commentaries = connector(CommentariesComponent);
